import { motion } from 'framer-motion';
import { Info } from 'lucide-react';

// Helper function to get plant name from item
function getPlantName(item) {
  // If plantName exists (new format), use it
  if (item.plantName) {
    return item.plantName;
  }

  // Otherwise, try to extract from plantInfo (old format)
  if (item.plantInfo) {
    // Look for "Common and Scientific Name" section
    const commonNameMatch = item.plantInfo.match(
      /Common and Scientific Name:([^(]+)/i
    );
    if (commonNameMatch && commonNameMatch[1]) {
      return commonNameMatch[1].trim();
    }

    // Fallback to first line if no match found
    return item.plantInfo.split('\n')[0].trim();
  }

  return 'Unknown Plant';
}

export function PlantHistoryItem({ item, onClick }) {
  const plantName = getPlantName(item);

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className="border rounded-lg p-4 hover:bg-gray-50 transition-colors cursor-pointer"
      onClick={() => onClick(item)}
    >
      <div className="flex items-start gap-3">
        <img
          src={item.imageUrl}
          alt="Plant"
          className="w-16 h-16 rounded-lg object-cover"
        />
        <div className="flex-1">
          <p className="font-medium text-gray-900">{plantName}</p>
          <p className="text-sm text-gray-500">
            {new Date(item.timestamp).toLocaleDateString()}
          </p>
        </div>
        <Info className="w-5 h-5 text-emerald-600" />
      </div>
    </motion.div>
  );
}
